import { action } from 'typesafe-actions';

export const ADDRESSES_REQUEST = 'ADDRESSES_REQUEST';
export const ADDRESSES_SUCCESSFUL = 'ADDRESSES_SUCCESSFUL';
export const ADDRESSES_FAILURE = 'ADDRESSES_FAILURE';
export const ADDRESSES_SELECT = 'ADDRESSES_SELECT';
export const ADDRESSES_EDIT = 'ADDRESSES_EDIT';
export const ADDRESSES_CLEAR_SELECT = 'ADDRESSES_CLEAR_SELECT';
export const ADDRESSES_LOCATION = 'ADDRESSES_LOCATION';

export const addressesRequest = () => action(ADDRESSES_REQUEST);

export const addressesSuccessful = (keyword: string, results: google.maps.places.AutocompletePrediction[]) =>
  action(ADDRESSES_SUCCESSFUL, { keyword, results });

export const addressesError = (error: string) => action(ADDRESSES_FAILURE, error);

export const addressesSelect = (selected: google.maps.places.AutocompletePrediction | google.maps.GeocoderResult) =>
  action(ADDRESSES_SELECT, { selected });

export const addressesEdit = (keyword: string) => action(ADDRESSES_EDIT, { keyword });

export const addressesLocation = (selected: google.maps.places.AutocompletePrediction) =>
  action(ADDRESSES_LOCATION, { selected });

export const addressesClearSelect = () => action(ADDRESSES_CLEAR_SELECT);
